import { render, staticRenderFns } from "./landing_about_signup.vue?vue&type=template&id=46973b66&"
import script from "./landing_about_signup.vue?vue&type=script&lang=js&"
export * from "./landing_about_signup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseNumberInput: require('/src/components/base/base_number_input.vue').default})
